/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_thin" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_thin" /></svg></button>';
	const urlParams = new URLSearchParams(window.location.search);
	const $path = location.pathname;
	const lang = $('html').attr('lang');
	let allNewsArr = []

	// ===========================================================================
	let $head = location.pathname.indexOf('/en/') !== -1 ? '/en/news/' : '/news/';
	let $unit = location.pathname.indexOf('/en/') !== -1 ? '' : '年';

	// JSON取得 =====================================================
	const getJSONrelatedNews = (_key) => {
		return $.getJSON(`/ajax/related_news/${_key}.json`);
	}
	// IRニュース（プロネクサス）
	const irNewsJsonJa = '//ssl4.eir-parts.net/V4Public/eir/9025/ja/announcement/announcement_31.js';
	const irNewsJsonEn = '//ssl4.eir-parts.net/V4Public/eir/9025/en/announcement/announcement_32.js';
	// ニュース（CMSoD
	const newsJsonJa = '/ajax/search/news_jp.json';
	const newsJsonEn = '/ajax/search/news_en.json';

	// ファイルサイズ
	const bytesToSize = (bytes) => {
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		if (bytes === 0) return '0 Byte';
		let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		let convSize = Math.floor(bytes / Math.pow(1024, i)* Math.pow(10, 1)) / Math.pow(10, 1);
		return convSize + sizes[i];
	};
	
	// 日付　プロネクサス
	const formatDatePronexus = (_date) => {
		let thisDate = new Date(_date);
		let year = thisDate.getFullYear();
		let month = ('0' + (thisDate.getMonth() + 1)).slice(-2); // 月は0始まりのため+1
		let day = ('0' + thisDate.getDate()).slice(-2);
		let formattedDate = `${year}.${month}.${day}`;
		return formattedDate;
	}
	// 英語用日付テキスト
	// const enFormatDate = (_date) => {
	// 	let [year, month, day] = _date.split('.');
	// 	const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
	// 	let monthName = monthNames[parseInt(month) - 1];
	// 	let formattedDate = `${monthName} ${parseInt(day)}, ${year}`;

	// 	return formattedDate;
	// }
	

	// 関連コンテンツ
	const relatedConts = () => {
		if($('.js-related-item').length) {
			$('.js-related-item').each((idx,ele) => {
				let thisKey = $(ele).find('.rt_cf_n_related_news_key').text();
				let thisType = $(ele).find('.rt_cf_n_related_news_type').text();
				// フリーレイアウトの場合のみカテゴリごとにURL出し分け
				if(thisType === '1') {
					getJSONrelatedNews(thisKey).then((data) => {
						let newsData = data.rt_bn_news_info;
						if (newsData.length) {
							let _cat = newsData[0].cf_n_category.cf_nc_code
							let _lang = newsData[0].cf_n_lang;
							let _key = newsData[0]. _key;
							let urlHead = '';

							if(_cat === 'release' || _cat === 'topics' || _cat === 'sustainability') {
								urlHead = 'news';
							} else if(_cat === 'service' || _cat === 'example' || _cat === 'dx') {
								urlHead = 'solution';
							} else {
								urlHead = _cat;
							}

							if(_lang === 1) { // 日本語
								$(ele).find('.mod-boxLink02').attr('href', `/${urlHead}/detail/${_key}.html`);
							} else { // 英語
								$(ele).find('.mod-boxLink02').attr('href', `/en/${urlHead}/detail/${_key}.html`);
							}
						}
					});
				};
			});
		}
	}

	// 関連コンテンツスライド
	const relatedContsSlider = () => {
		if($('.js-related-slider').length) {
			$('.js-related-slider').slick({
				infinite: true,
				speed: 1000,
				autoplay: false,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 4,
				arrows: true,
				dots: false,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							arrows: false,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
						},
					}
				]
			});
		}
	};

	// 年号プルダウン
	const yearSelect = (_irLatestY, _irOldestY) => {
		// 年号プルダウン
		const selectYear = $('.js-select-year');
		if(selectYear.length) {
			let cmsLatestY = $('.js-news-latest-year').text();
			let cmsOldestY = $('.js-news-earliest-year').text();
			let latestY = Math.max(_irLatestY, cmsLatestY);
			let oldestY = Math.min(_irOldestY, cmsOldestY);
			let yearArr = [];
			let selectedY = '';
			// 年号セレクトボックス生成
			for(let i = latestY; i > oldestY-1; i--) {
				yearArr.push(Number(i));
				if(location.pathname.indexOf(i) !== -1) {
					selectYear.append(`<option value="${i}" selected="selected">${i}${$unit}</option>`);
					selectedY = i;
				} else {
					selectYear.append(`<option value="${i}">${i}${$unit}</option>`);
				}
			}

			// 選択済みのカテゴリ
			let selectedC = new URLSearchParams(window.location.search).get('p_category');
			if(selectedC !== '' && selectedC !== null) {
				$('.js-select-category').removeClass(a);
				$('.js-select-category[data-name="'+ selectedC +'"]').addClass(a);
			}
			
			// 注釈表示／非表示
			if((selectedC === '' || selectedC === null) && (selectedY < 2019 && selectedY !== '')) {
				$('.js-news-all').removeClass('di_none');
			} else if(selectedC !== 'ir' && (selectedY < 2019 && selectedY !== '')) {
				let thisCatName = $('.js-select-category[data-name="'+ selectedC +'"]').text();
				$('.js-news-other-category').text(thisCatName.replace(/\s+/g, ''));
				$('.js-news-other').removeClass('di_none');
			}
			
			if($(window).width() > 1024) {
				// PC
				if($('.js-select-category').length) {
					$('.js-select-category').each((idx,ele) => {
						let thisCat = $(ele).attr('data-name');
						let thisParam = '?p_category='+ thisCat;
						if(thisCat === '') {
							thisParam = '';
						}
						if(selectedY === '') {
							$(ele).attr('href', $head + thisParam);
						} else {
							$(ele).attr('href', $head + selectedY +'/'+ thisParam);
						}
					});
				}
			} else {
				// TABLE/SP
				$('.js-select-category-sp option[value="'+ selectedC +'"]').prop('selected', true);
				$('.js-select-category-sp').on('change', (e) => {
					let thisCat = $(e.currentTarget).val();
					let thisParam = '?p_category='+ thisCat;
					if(thisCat === '') {
						thisParam = '';
					}
					if(selectedY === '') {
						location.href = $head + thisParam;
					} else {
						location.href = $head + selectedY +'/'+ thisParam;
					}
				});
			}
			
			// 年号プルダウンチェンジ
			selectYear.on('change', (e) => {
				let thisY = $(e.currentTarget).val();
				if(thisY === '') {
					location.href = location.pathname.replace(selectedY +'/', '') + location.search;
				} else {
					if(selectedY === '') {
						location.href = location.pathname + thisY +'/'+ location.search;
					} else {
						location.href = location.pathname.replace(selectedY, thisY) + location.search;
					}
				}
			});
		}
	}

	// IR・決算情報（プロネクサス）
	const createIrNews = () => {
		const output = $('.js-news-output');
		const jsonUrl = lang === 'ja' ? irNewsJsonJa : irNewsJsonEn;
		let selectYear = $path.split('/')[$path.split('/').length - 2];
		const pattern = /^\d{4}$/;
		if(pattern.test(selectYear) === false) {
			selectYear = '';
		}
		// let cmsOldestY = $('.js-news-earliest-year').text();

		let pdfIcon = '<svg class="icon _pdf"><use xlink:href="/common/svg/sprite.svg#pdf2"></use></svg>'
		let blankIcon = '<svg class="icon _blank" style="width:16px; height="16px"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg>'

		const today = new Date(); // 現在日時
		const sevenDaysAgo = new Date(today); // 7日間前
		sevenDaysAgo.setDate(today.getDate() - 7);
		
		const categoryTxt = (_cat) => {
			if(_cat === 'tanshin') {
				return '決算'
			} else if(_cat === 'press') {
				return '適時開示'
			} else if(_cat === "yuho") {
				return '決算'
			} else if(_cat === "announcement") {
				return '株主総会'
			} else if(_cat === "ir_material_for_fiscal_ym") {
				return 'IR資料'
			}
		}

		function getParameterByName(url, name) {
			const urlObj = new URL(url);
			const params = new URLSearchParams(urlObj.search);
			return params.get(name);
		}
		const url = location.href;
		const categoryValue = getParameterByName(url, 'p_category');

		if(output) {
			fetch(jsonUrl)
			.then(response => response.text())
			.then((data) => {
				if(data.length) {
					output.removeClass('di_none');

					data = data.replace(/\r?\n/g,"");
					let match = data.match(/\((\{.*\})\)/)
					if (match) {
						let jsonText = match[1];
						try {
							let jsonData = JSON.parse(jsonText);
							let newsItem = jsonData.item;
							// typeが"space"のアイテムを削除
							newsItem = newsItem.filter(function(item) {
								return item.type !== "space";
							});
							let limit = selectYear === '' ? 10 :newsItem.length;

							// プロネクサスのニュースの年号を含めたプルダウンを生成
							let irLatestY = new Date((newsItem[0].date)).getFullYear();
							let irOldestY = new Date(newsItem[newsItem.length - 1].date).getFullYear();
							yearSelect(irLatestY, irOldestY);
							
							if(categoryValue === 'ir' || categoryValue === null) {
								for(let i=0; i < limit; i++) {
									let thisTit = newsItem[i].title;
									let thisDate = newsItem[i].date;
									let thisFormatDate = newsItem[i].format_date;
									let thisCat = newsItem[i].news_type;
									let thisLink = newsItem[i].link;
									let thisType = newsItem[i].type;
									let fileSize = newsItem[i].file_size;
									let linkIcon = thisType === 'pdf' ? pdfIcon : blankIcon;
									let fileSizeTxt = fileSize === '' ? '' : `<span class="__size">（${fileSize}KB）`;
									let formatedDate = formatDatePronexus(thisDate).replace(/\./g, '-');
									let newsCat = lang === 'ja' ? categoryTxt(thisCat) : 'IR Library';
									
									// 現在から7日間以内の場合newマーク表示
									let targetDate = new Date(thisDate);
									let newIcon = '';
									if (targetDate >= sevenDaysAgo && targetDate <= today || targetDate >= today) {
										newIcon = '<span class="__new">NEW</span>';
									}


									let thisHtml = `<li class="mod-newsList02">
										<time class="__date" datetime="${formatedDate}">${thisFormatDate}</time>
										<div class="mod-newsList02-inner"><span class="mod-label">${newsCat}</span>
										<a href="${thisLink}" target="_blank" class="mod-newsList02-txt"><span class="mod-newsList02-txt-inner"><span class="__tit">${thisTit}</span>
										${linkIcon}${fileSizeTxt}</span>${newIcon}</a></div></li>`
									
									allNewsArr.push({datetime : targetDate, html : thisHtml});

									if(categoryValue === 'ir') {
										if(selectYear === '') {
											output.append(thisHtml)
										} else {
											if(formatedDate.split('-')[0] === selectYear) {
												output.append(thisHtml);
											}
										}
									}
								}
							};

						} catch (error) {
							console.error("JSONのパース中にエラーが発生しました:", error);
						}
					} else {
						console.error("JSON部分の抽出に失敗しました");
					}
				}
				
			})
			.then(() => {
				createNews();
			})
			.catch(error => {
				console.error('Error fetching file:', error);
			});
		}
	}
	// CMSoDニュース
	const createNews = () => {
		const output = $('.js-news-output');
		const pCategory = urlParams.get('p_category');
		const jsonUrl = lang === 'ja' ? newsJsonJa : newsJsonEn;
		let selectYear = $path.split('/')[$path.split('/').length - 2];
		const pattern = /^\d{4}$/;
		if(pattern.test(selectYear) === false) {
			selectYear = '';
		}
		let pdfIcon = '<svg class="icon _pdf"><use xlink:href="/common/svg/sprite.svg#pdf2"></use></svg>'
		let blankIcon = '<svg class="icon _blank" style="width:16px; height="16px"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg>'
		
		const today = new Date(); // 現在日時
		const sevenDaysAgo = new Date(today); // 7日間前
		sevenDaysAgo.setDate(today.getDate() - 7);

		if(output) {
			fetch(jsonUrl)
			.then(response => response.json())
			.then((data) => {
				const newsData = data.rt_bn_news_list;
				if(newsData.length) {
					
					let count = 0;
					for(let i=0; i < newsData.length; i++) {
						let thisTit = newsData[i].cf_n_title;
						let thisDate = newsData[i].rt_cf_n_date;
						let thisCat = newsData[i].cf_n_category;
						let thisLink = newsData[i].rt_cf_n_href.href;
						let thisLinkTarget = newsData[i].rt_cf_n_href.target;
						let fileSize = newsData[i].cf_n_attachment_file_size;
						let thisTag =  newsData[i].cf_n_tags;
						let thisType = newsData[i].cf_n_type; // 1:フリーレイアウト、2:テンプファイル、3:URL指定、4:イベント、5:テキスト表示
						let newsCatCode = thisCat.cf_nc_code;
						let newsCatTxt = lang === 'ja' ? thisCat.cf_nc_name : thisCat.cf_nc_name_en;
						let dateTxt = thisDate.content;
						let formatedDate = thisDate.datetime;
						let targetDate = new Date(newsData[i].cf_n_date);

						// 現在から7日間以内の場合newマーク表示
						let newIcon = '';
						if (targetDate >= sevenDaysAgo && targetDate <= today || targetDate >= today) {
							newIcon = '<span class="__new">NEW</span>';
						}
						
						let tagsHtml = '';
						if(thisTag.length) {
							tagsHtml = '<div class="mod-newsList02-tag">';
							thisTag.forEach((ele,idx) => {
								tagsHtml += `<span class="__tag"><a href="${$head}tags/${ele.cf_nt_url}/">`;
								tagsHtml += lang === 'ja' ? ele.cf_nt_name_d : ele.cf_nt_name_d_en;
								tagsHtml += '</a></span>'
							});
							tagsHtml += '</div>';
						}

						let linkIcon = '';
						let thisTarget = '_self';
						if(thisLinkTarget === '_blank') {
							linkIcon = blankIcon;
							thisTarget = '_blank';
						}
						if(thisLink.endsWith('pdf')) {
							linkIcon = pdfIcon;
						}
						let fileSizeTxt = fileSize === null ? '' : ` <span class="__size">（${bytesToSize(fileSize)}）`;

						// テキスト表示
						let linkClass = '';
						if(thisType === 5) {
							linkClass = 'is-disable';
						}

						let thisHtml = `<li class="mod-newsList02">
							<time class="__date" datetime="${formatedDate}">${dateTxt}</time>
							<div class="mod-newsList02-inner"><span class="mod-label">${newsCatTxt}</span>${tagsHtml}<a href="${thisLink}" target="${thisTarget}" class="mod-newsList02-txt ${linkClass}"><span class="mod-newsList02-txt-inner"><span class="__tit">${thisTit}</span>
							${linkIcon}${fileSizeTxt}</span>${newIcon}</a></div></li>`;
						
						allNewsArr.push({datetime : targetDate, html : thisHtml});

						if(selectYear === '') { // 最新
							if(pCategory === newsCatCode) {
								count += 1;
								if(count < 11) {
									output.append(thisHtml)
								} else {
									break;
								}
							}
						} else { // 年ごと
							if(formatedDate.split('-')[0] === selectYear) {
								if(pCategory === newsCatCode) {
									output.append(thisHtml);
								}
							}
						}
						
					};
				}
			})
			.then(() => {
				// 「すべて」
				if(pCategory === null) {
					allNewsArr.sort(
						function(x, y){
							let xDate = x['datetime'];
							let yDate = y['datetime'];
							if(xDate > yDate) return-1;
							if(xDate < yDate) return 1;
							return 0;
						}
					);
					
					if(selectYear === '') {
						for(let i=0; i<10; i++) {
							output.append(allNewsArr[i].html);
						}
					} else {
						allNewsArr.forEach((ele,idx) => {
							if(ele.datetime.getFullYear() == selectYear) {
								output.append(ele.html);
							}
						})
					}
				}
			}).then(() => {
				const newsItem = $('.js-news-output .mod-newsList02');
				if(!newsItem.length) {
					if(selectYear >= 2019) {
						$('.js-0-msg').removeClass('di_none');
					} else if(selectYear === '') {
						if($('.js-news-other.di_none')) {
							$('.js-0-msg').removeClass('di_none');
						}
					}
				}
			})
			.catch(error => {
				// エラーハンドリング
				console.error('Error:', error);
			});
		}
	}



	// ==============================================================================
	relatedConts();
	relatedContsSlider();
	if($path.indexOf('/tags/') !== -1 || $path.indexOf('/sustainability/') !== -1) {
		if($('.js-news-latest-year').length) {
			let cmsLatestY = $('.js-news-latest-year').text();
			let cmsOldestY = $('.js-news-earliest-year').text();
			yearSelect(cmsLatestY, cmsOldestY);
		}
	} else {
		createIrNews();
	}

})(window.jQuery, window.KONOIKE);
